import { useEffect, useRef } from 'react'
import { tm } from '../tm'
import type { CSSProperties } from 'react'

const VARIANTS = {
  small:
    'h-[150px] sm:h-[200px] sm:w-[300px] md:h-[250px] md:w-[400px] lg:h-[200px] lg:w-[400px] xl:w-[500px]',
  large:
    'h-[300px] sm:h-[400px] sm:w-[600px] md:h-[500px] md:w-[800px] lg:h-[400px] lg:w-[800px] xl:w-[1000px]',
}

interface YoutubeIframeProps {
  id: string
  variant?: keyof typeof VARIANTS
  className?: string
  style?: CSSProperties
}

export function YoutubeIframe({
  id,
  variant = 'small',
  className = '',
  style = undefined,
}: YoutubeIframeProps) {
  const iframe = useRef<HTMLIFrameElement | null>(null)

  useEffect(() => {
    const { current: element } = iframe
    if (!element) return () => {}

    const observer = new IntersectionObserver(
      entries => {
        if (entries[0].intersectionRatio > 0 && !element.src) {
          element.src = `https://www.youtube.com/embed/${id}`
        }
      },
      {
        threshold: 0.1,
      },
    )

    observer.observe(element)

    return () => {
      observer.disconnect()
    }
  }, [id])

  return (
    <iframe
      ref={iframe}
      className={tm(
        'mx-auto mt-6 w-full rounded-md',
        VARIANTS[variant],
        className,
      )}
      title="YouTube video player"
      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
      allowFullScreen
      loading="lazy"
      width={1000}
      height={400}
      style={style}
    />
  )
}
